module.exports = __webpack_public_path__ + "img/mute.df33d43f.png";